import { render, staticRenderFns } from "./InterventionSetupEdit.vue?vue&type=template&id=24525e8c"
import script from "./InterventionSetupEdit.vue?vue&type=script&lang=ts"
export * from "./InterventionSetupEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports